import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { FETCH_FB_COMMENTS, FETCH_QB_COUNTRIES } from "../actions/facebookCommentsAction";

const facebookCommentsReducer = (
    state = {
        fbCommentsList: [],
        fbCommentsLoading: false,
        countryListLoading: false,
        countryList: [],
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_FB_COMMENTS):
            return (state = {
                ...state,
                fbCommentsLoading: true,
                fbCommentsList: [],
            });
        case isRejected(FETCH_FB_COMMENTS):
            return (state = {
                ...state,
                fbCommentsLoading: false,
                fbCommentsList: [],
            });
        case isFulfilled(FETCH_FB_COMMENTS):
            return (state = {
                ...state,
                fbCommentsLoading: false,
                fbCommentsList: action.payload,
            });
        case isPending(FETCH_QB_COUNTRIES):
            return (state = {
                ...state,
                countryListLoading: true,
                countryList: [],
            });
        case isRejected(FETCH_QB_COUNTRIES):
            return (state = {
                ...state,
                countryListLoading: false,
                countryList: [],
            });
        case isFulfilled(FETCH_QB_COUNTRIES):
            return (state = {
                ...state,
                countryListLoading: false,
                countryList: action.payload,
            });
        default:
            return state;
    }
};

export default facebookCommentsReducer;
